module.exports = __webpack_public_path__ + "img/logorodopetit.f780990e.png";